import HttpService from '@/api/HttpService';
import TransactionDetail from '@/entities/transactionDetail';
import {
  SET_TRANSACTION,
  GET_TRANSACTION_LIST_FAILURE,
  GET_TRANSACTION_LIST_REQUEST,
  GET_TRANSACTION_LIST_SUCCESS,
  DISABLE_SUBMIT_DETAIL_TRANSACTION,
  ENABLE_SUBMIT_DETAIL_TRANSACTION,
  UPDATE_UPCOMING_TRANSACTION_REQUEST,
  UPDATE_UPCOMING_TRANSACTION_RESPONDED,
} from '../mutation-types';

export default {
  namespaced: true,
  state: {
    transaction: {},
    loading: false,
    disableSubmitDetailTransaction: false,
  },
  mutations: {
    [SET_TRANSACTION](state, transaction) {
      if (Object.keys(transaction).length === 0) {
        state.transaction = Object.assign({}, new TransactionDetail());
        return;
      }
      state.transaction = Object.assign({}, transaction);
    },
    [GET_TRANSACTION_LIST_FAILURE](state) {
      state.loading = false;
    },
    [GET_TRANSACTION_LIST_REQUEST](state) {
      state.loading = true;
    },
    [GET_TRANSACTION_LIST_SUCCESS](state) {
      state.loading = false;
    },
    [ENABLE_SUBMIT_DETAIL_TRANSACTION](state) {
      state.disableSubmitDetailTransaction = false;
    },
    [DISABLE_SUBMIT_DETAIL_TRANSACTION](state) {
      state.disableSubmitDetailTransaction = true;
    },
    [UPDATE_UPCOMING_TRANSACTION_REQUEST](state) {
      state.loading = true;
    },
    [UPDATE_UPCOMING_TRANSACTION_RESPONDED](state) {
      state.loading = false;
    },
  },
  actions: {
    getTransaction({ commit }, transactionId) {
      return HttpService.getV2(`transactions/${transactionId}`)
        .catch((err) => {
          throw err;
        });
    },
    getFailedCancelledTransactions({ commit }) {
      commit(GET_TRANSACTION_LIST_REQUEST);
      return HttpService.getV2('transactions/failed-cancelled')
        .then((response) => {
          commit(GET_TRANSACTION_LIST_SUCCESS);
          return response;
        })
        .catch((err) => {
          commit(GET_TRANSACTION_LIST_FAILURE);
          throw err;
        });
    },
    retryTransaction({ commit }, transactionId) {
      commit(DISABLE_SUBMIT_DETAIL_TRANSACTION);
      return HttpService.post(`transactions/${transactionId}/retry`)
        .then((response) => {
          commit(ENABLE_SUBMIT_DETAIL_TRANSACTION);
          return response;
        })
        .catch((error) => {
          commit(ENABLE_SUBMIT_DETAIL_TRANSACTION);
          throw error;
        });
    },
    retryFailedTransaction({ commit }, payload) {
      const { transactionId, comment, accountId, fundingSourceId } = payload;
      return HttpService.postV2(
        `/transactions/${transactionId}/retry`,
        {
          comment,
          accountId,
          fundingSourceId,
        },
      )
        .then(response => response)
        .catch((err) => {
          throw err;
        });
    },
    saveLostComment({ commit }, { id, comment }) {
      commit(DISABLE_SUBMIT_DETAIL_TRANSACTION);
      return HttpService.patchV2(`transactions/${id}`, { comment })
        .then((response) => {
          commit(ENABLE_SUBMIT_DETAIL_TRANSACTION);
          return response;
        })
        .catch((error) => {
          commit(ENABLE_SUBMIT_DETAIL_TRANSACTION);
          throw error;
        });
    },
    lostTransaction({ commit }, { transactionId }) {
      commit(DISABLE_SUBMIT_DETAIL_TRANSACTION);
      return HttpService.putV2(`transactions/${transactionId}/lost`)
        .then((response) => {
          commit(ENABLE_SUBMIT_DETAIL_TRANSACTION);
          return response;
        })
        .catch((error) => {
          commit(ENABLE_SUBMIT_DETAIL_TRANSACTION);
          throw error;
        });
    },
    updateTransaction({ commit }, { transactionId, payload }) {
      return HttpService.patchV2(`transactions/${transactionId}`, payload)
        .then(response => response)
        .catch((error) => {
          throw error;
        });
    },
    getAccountTransactionsSummary({ commit }, { accountId }) {
      return HttpService.getV2(`accounts/${accountId}/transactions/summary`)
        .then(response => response)
        .catch((err) => {
          throw err;
        });
    },
    updateUpcomingTransaction({ commit }, { payload, transactionId }) {
      commit(UPDATE_UPCOMING_TRANSACTION_REQUEST);
      return HttpService.putV2(`transactions/upcoming/${transactionId}`, payload)
        .then((response) => {
          commit(UPDATE_UPCOMING_TRANSACTION_RESPONDED);
          return response;
        })
        .catch((error) => {
          commit(UPDATE_UPCOMING_TRANSACTION_RESPONDED);
          throw error;
        });
    },
    updateUpcomingTransactionByAdmin({ commit }, { payload, transactionId }) {
      commit(UPDATE_UPCOMING_TRANSACTION_REQUEST);
      return HttpService.put(
        `upcoming-transactions/${transactionId}/admin`,
        payload,
      )
        .then((response) => {
          commit(UPDATE_UPCOMING_TRANSACTION_RESPONDED);
          return response;
        })
        .catch((error) => {
          commit(UPDATE_UPCOMING_TRANSACTION_RESPONDED);
          throw error;
        });
    },
    setTransactionAsProcessed({ commit }, { transactionId }) {
      return HttpService.putV2(`transactions/${transactionId}/process-manually`)
        .then(response => response)
        .catch(error => Promise.reject(error));
    },
    markTransactionAsFailed({ commit }, { id, ...body }) {
      return HttpService.postV2(`transactions/${id}/mark-as-failed`, body)
        .then(response => response)
        .catch(error => Promise.reject(error));
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/transaction.js